import React from "react";
import ChildInfoCard from "../../shared/components/ChildInfoCard";

export default function ChildDetailsStats({ stats }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-5">
      {stats.map((stat) => (
        <ChildInfoCard
          key={stat.label}
          label={stat.label}
          value={stat.value}
          helper={stat.helper}
          tone={stat.tone}
          icon={stat.icon}
          onClick={stat.onClick}
          ariaLabel={stat.ariaLabel}
          className="min-h-[150px]"
        />
      ))}
    </div>
  );
}
